import axios from 'axios';
import { config } from '@/config/config';

export default class AssetService {
	public static loadCodeSnippet(): Promise<string> {
		const url = config().webAssistantLoaderUrl;

		return axios(url, {
			method: 'GET',
			responseType: 'text'
		}).then(response => {
			if (response.status >= 400) {
				// check for 4XX, 5XX
				return Promise.reject({
					status: response.status,
					message: response.statusText
				});
			}
			if (response.status >= 200 && response.status <= 202) {
				return response.data;
			}
			return {};
		});
	}
}
